import {
  Flex,
  useDisclosure
 } from "@chakra-ui/react";

import { Footer } from "./Footer";
import { Header } from "./Header";
import { CardModal } from "./Modal";

interface ScheduleCardProps {
  canceled?: boolean;
  waiting?: boolean;
  eventId: string;
  title: string;
  description: string;
  date: string;
  startHour: string;
  endHour: string;
  duration: string;
  credit: string;
  levels?: {
    id: string;
    level: {
      name: string;
      color: string;
      variant: string;
    };
  }[]
  disabled?: boolean;
  eventHasSubject?: boolean;
  startDateISO: string;
  dayOfWeek: string;
  setHighlight?: boolean;
  forTeachers?: boolean;
  descriptionFormatted: string;
  classSubject?: string | null
}

export function ScheduleCard({
  canceled = false,
  waiting = false,
  disabled = false,
  eventId,
  title,
  levels,
  description,
  date,
  startHour,
  endHour,
  duration,
  credit,
  eventHasSubject = false,
  startDateISO,
  dayOfWeek,
  setHighlight = false,
  forTeachers = false,
  descriptionFormatted,
  classSubject = null
}: ScheduleCardProps) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Flex
      as="article"
      border={ setHighlight ? "2px" : "1px" }
      borderColor={ setHighlight ? "green.500" : "none" }
      borderRadius="5"
      padding={1}
      bg={
        disabled
        ? "gray.50"
        : setHighlight
          ? "green.50"
          : "white"
      }
      flexDir="column"
      justifyContent="space-between"
    >
      <Header
        title={title}
        starthour={startHour}
        endHour={endHour}
        levels={levels}
      />

      <Footer
        onOpen={onOpen}
        waiting={waiting}
        disabled={disabled}
      />

      <CardModal
        isOpen={isOpen}
        onClose={onClose}
        eventId={eventId}
        title={title}
        description={descriptionFormatted || description}
        duration={duration}
        waiting={waiting}
        canceled={canceled}
        startDate={date}
        startHour={startHour}
        credit={credit}
        eventHasSubject={eventHasSubject}
        startDateISO={startDateISO}
        classSubject={classSubject}
        levels={levels}
      />
    </Flex>
  );
}
